import React, { useState } from 'react';
import { Button, Card, Space, Typography } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import ZoneMappingImportModal from './components/ZoneMappingImportModal';

const { Title, Paragraph } = Typography;

const ZoneMappingPage: React.FC = () => {
  const [importModalVisible, setImportModalVisible] = useState(false);

  const handleImportSuccess = () => {
    setImportModalVisible(false);
    // 可以在这里刷新列表或显示成功消息
  };

  return (
    <div className="p-6">
      <Card>
        <div className="mb-6">
          <Title level={2}>Zone映射管理</Title>
          <Paragraph className="text-gray-600 mt-2">
            管理始发地Zipcode到目标Zipcode的Zone映射规则。支持通过Excel文件批量导入映射数据。
          </Paragraph>
        </div>

        <Space>
          <Button
            type="primary"
            icon={<UploadOutlined />}
            size="large"
            onClick={() => setImportModalVisible(true)}
          >
            导入Zone映射
          </Button>
        </Space>

        <ZoneMappingImportModal
          visible={importModalVisible}
          onCancel={() => setImportModalVisible(false)}
          onSuccess={handleImportSuccess}
        />
      </Card>
    </div>
  );
};

export default ZoneMappingPage;

